/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Absences_SuccessInputs */

const es_tools_legajox_absences_success = /** @type {(inputs: Tools_Legajox_Absences_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausencias de Legajox consultadas`)
};

const en_tools_legajox_absences_success = /** @type {(inputs: Tools_Legajox_Absences_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox absences queried`)
};

/**
* | output |
* | --- |
* | "Legajox absences queried" |
*
* @param {Tools_Legajox_Absences_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_absences_success = /** @type {((inputs?: Tools_Legajox_Absences_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Absences_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_absences_success(inputs)
	return en_tools_legajox_absences_success(inputs)
});
export { tools_legajox_absences_success as "tools.legajox.absences_success" }